import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
// styles
import styles from "./styles";

class FormInstrument extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,
    instrumentSections: PropTypes.array,

    close: PropTypes.func,
    open: PropTypes.bool,

    instrument: PropTypes.object,

    createInstrument: PropTypes.func,
    updateInstrument: PropTypes.func,
    deleteInstrument: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      sectionID: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.instrument);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(instrument) {
    this.setState({
      loading: false,
      name: instrument ? instrument.name : "",
      sectionID: instrument ? instrument.sectionID : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this instrument, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteInstrument, close, refresh, instrument } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteInstrument(instrument.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Instrument has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateInstrument,
      createInstrument,
      instrument,
      refresh,
      close,
    } = this.props;

    const { name } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (instrument) {
      resp = await updateInstrument(instrument.id, {
        name,
      });
    } else {
      resp = await createInstrument({
        name,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: instrument
          ? "Instrument has been updated."
          : "Instrument has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, instrument, close } = this.props;

    const { name, loading } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {instrument
                ? `${instrument.name}`
                : "Let's Create a New Instrument"}
              {instrument ? (
                <Typography variant="caption" color="textSecondary">
                  #{instrument.id}
                </Typography>
              ) : (
                <div />
              )}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {instrument
                  ? "To update the instrument, fill the form below :"
                  : "To create a new instrument, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                {/* <Grid item xs={12}>
                      <FormControl className={classes.formControl} fullWidth>
                        <InputLabel htmlFor="Section-simple">Section</InputLabel>
                        <Select
                          inputProps={{
                            name: 'Section',
                            id: 'Section-simple',
                          }}
                          value={sectionID}
                          onChange={this.handleChange('sectionID')}
                        >
                          {
                            instrumentSections.map(s => (
                              <MenuItem key={`instrumentSection_${s.id}`} value={s.id}>
                                {s.name}
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </Grid> */}
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {instrument && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {instrument ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormInstrument));
